import { render, staticRenderFns } from "./ProjetoGet.vue?vue&type=template&id=4478860d&scoped=true"
import script from "./ProjetoGet.vue?vue&type=script&lang=js"
export * from "./ProjetoGet.vue?vue&type=script&lang=js"
import style0 from "./ProjetoGet.vue?vue&type=style&index=0&id=4478860d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4478860d",
  null
  
)

export default component.exports